import { HashRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import RiderList from "../pages/Rider/RiderList";
import CreateRider from "../pages/Rider/CreateRider";
import EditRider from "../pages/Rider/EditRider";
//@ts-ignore
import { PermissionRequired, AccessControl} from "@careinfo/permission-required";

export const queryClient = new QueryClient()

const Router = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <HashRouter>
        <Routes>
          <Route path="/" element={<RiderList />} />
          <Route path="/rider" element={<RiderList />} />
          <Route path="/create" element={
            <AccessControl
            children={
            <CreateRider />
            }
            allowedPermissions={["can_create_rider"]}
            />
          } />
          <Route path="/edit/:id" element={
               <AccessControl
               children={
                <EditRider />
               }
               allowedPermissions={["can_update_rider"]}
               />
            } />
        </Routes>
      </HashRouter>
      <ToastContainer autoClose={500} draggablePercent={30} />
    </QueryClientProvider>

  );
};

export default Router;